import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AppAdminGuard  {
	constructor() {
	}
	
	canActivate(): Observable<boolean> | Promise<boolean> | boolean {
		return true;
	}
	
	canLoad(): Observable<boolean> | Promise<boolean> | boolean {
		return true;
	}
}
